import { Inject, Injectable } from '@angular/core';
import { RULES_REPOSITORY, RulesRepository } from '@core/repositories/rules.repository';
import { Rule } from '@shared/interfaces/rule';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RulesService {
  constructor(
    @Inject(RULES_REPOSITORY) protected repository: RulesRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(rule: Rule): Observable<any> {
    return this.repository.add(rule);
  }

  edit(rule: Rule): Observable<any> {
    return this.repository.edit(rule);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
